'use strict';



const $ = require('jquery');
const cookies = require('cookies-js');
const debounce = require('debounce');

const $toggle = $('[data-set-view-preference]');
const $views = $('[data-view-type]');
const $root = $('body');

const cookieName = 'view-preference';
const activeControlClassName = 'is-active';
const debouncedRender = debounce(render.bind(null, null), 600);
const types = [ 'grid', 'list' ];
const defaultType = 1;
const forceGridMaxWidth = 985;

let _preference;



getPreference();



$toggle.on('click', function() {
	const type = $(this).data('set-view-preference');
	setPreference(types.indexOf(type));
});



$(window).on('resize', debouncedRender);



function getPreference() {

	if(_preference) {
		return _preference;
	}

	const cookie = cookies.get(cookieName);
	return setPreference(cookie);

}



function setPreference(preference = defaultType) {

	if(_preference && _preference === preference) {
		return _preference;
	}

	_preference = preference;

	cookies.set(cookieName, preference, {
		expires: Infinity
	});

	render();

	return preference;

}



function render() {

	const typeName = window.innerWidth < forceGridMaxWidth ?
		types[0] :
		types[getPreference()];

	const $activeView = $views.filter(`[data-view-type=${typeName}]`);
	const $inactiveView = $views.filter(`:not([data-view-type=${typeName}])`);

	const $activeControl = $toggle.filter(`[data-set-view-preference=${typeName}]`);
	const $inactiveControl = $toggle.filter(`:not([data-set-view-preference=${typeName}])`);

	$activeView.show();
	$inactiveView.hide();

	$activeControl.addClass(activeControlClassName);
	$inactiveControl.removeClass(activeControlClassName);

}